import { Injectable } from '@angular/core';
import { BaseSiteService, TranslationService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, switchMap } from 'rxjs';
import { failStatus, successStatus } from '../../../../../../core/models/request-status.model';
import { ThemeRequest } from './theme.model';
import { NDBSTheme } from '../themes/ndbs.theme';
import { normalizeTheme } from './theme.normalizer';

@Injectable({
  providedIn: 'root',
})
export class StyleThemeAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private baseSiteService: BaseSiteService,
  ) {}

  fetchTheme(): Observable<ThemeRequest> {
    return this.baseSiteService.getActive().pipe(
      switchMap(baseSiteID => {
        const url = `https://jsonplaceholder.typicode.com/users` + `?baseSiteID=` + baseSiteID;
        // const url = this.occEndPointService.buildUrl('theme');

        return this.http.get(url).pipe(
          map(() => ({
            theme: normalizeTheme(NDBSTheme.light),
            ...successStatus,
          })),
          catchError(() => {
            return this.translationService.translate('generic.error').pipe(
              map(textError => ({
                ...failStatus,
                message: textError,
              })),
            );
          }),
        );
      }),
    );
  }
}
